// extracted by mini-css-extract-plugin
module.exports = {"component":"LinkButton_component__2HuWV","small":"LinkButton_small__RhB43","outlined":"LinkButton_outlined__31LsT"};